import axios from 'axios';
import {eaRest, eaCsrf, eaLanguage} from 'helpers/ea';

const Api = axios.create({
    baseURL: eaRest,
    headers: {
        'Content-Type': 'application/json',
        //'X-WP-Nonce': csrfToken
    }
});

if(eaCsrf) {
    Api.defaults.headers.common['X-WP-Nonce'] = eaCsrf.content;
}

Api.interceptors.request.use((config) => {
    if(!eaLanguage) return config;

    if(config.params instanceof URLSearchParams) {
        if(!config.params.has('lang')) {
            config.params.set('lang', eaLanguage);
        }
        return config;
    }

    config.params = {
        ...(config.params || {}),
        lang: config.params?.lang || eaLanguage,
    };

    return config;
});

export default Api;
